import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { printInventory } from '../Api'

export default generateApiAction({
  baseType: Types.PRINT.INVENTORY,
  api: printInventory,
  responseType: RESPONSETYPE.FILE
})



// WEBPACK FOOTER //
// ./src/actions/print/PrintInventoryAction.js